<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ clientIcon }}</md-icon>
            </div>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method="post">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Name</label>
                    <md-input
                      v-model="form.name"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Address 1</label>
                    <md-input
                      v-model="form.address1"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Address 2</label>
                    <md-input v-model="form.address2" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Address 3</label>
                    <md-input v-model="form.address3" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>City</label>
                    <md-input
                      v-model="form.city"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>County</label>
                    <md-input v-model="form.county" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Postcode</label>
                    <md-input
                      v-model="form.postcode"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Country</label>
                    <md-input
                      v-model="form.country"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <h4>Stat. Insp. Intervals</h4>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-30">
                  <md-checkbox v-model="form.statutoryInspectionsEnabled"
                    >Enable Statutory Inspections:</md-checkbox
                  >
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field v-show="form.statutoryInspectionsEnabled">
                    <label>Reminder Interval</label>
                    <md-select v-model="form.reminderIntervalInWeeks" required>
                      <md-option :value="0">Never</md-option>
                      <md-option :value="1">1 Week</md-option>
                      <md-option :value="2">2 Weeks</md-option>
                      <md-option :value="3">3 Weeks</md-option>
                      <md-option :value="4">4 Weeks</md-option>
                      <md-option :value="5">5 Weeks</md-option>
                      <md-option :value="6">6 Weeks</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field v-show="form.statutoryInspectionsEnabled">
                    <label>Overdue Interval</label>
                    <md-select v-model="form.overdueIntervalInWeeks" required>
                      <md-option :value="1">1 Week</md-option>
                      <md-option :value="2">2 Weeks</md-option>
                      <md-option :value="3">3 Weeks</md-option>
                      <md-option :value="4">4 Weeks</md-option>
                      <md-option :value="5">5 Weeks</md-option>
                      <md-option :value="6">6 Weeks</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success md-sm"
              :disabled="hasSubmit"
              ><md-icon class="material-icons">check</md-icon>Submit</md-button
            >
            <md-button class="md-danger md-sm" @click="onCancel"
              ><md-icon class="material-icons">close</md-icon>Cancel</md-button
            >
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddClient",
  data() {
    return {
      hasSubmit: false,
      form: {
        name: undefined,
        address1: undefined,
        address2: undefined,
        address3: undefined,
        city: undefined,
        county: undefined,
        postcode: undefined,
        country: undefined,
        primaryContactName: undefined,
        primaryContactPhoneNumber: undefined,
        primaryContactEmailAddress: undefined,
        secondaryContactName: undefined,
        secondaryContactPhoneNumber: undefined,
        secondaryContactEmailAddress: undefined,
        statutoryInspectionsEnabled: false,
        reminderIntervalInWeeks: 0,
        overdueIntervalInWeeks: 1
      }
    };
  },
  computed: {
    ...mapGetters({
      clientIcon: "data-management-client/icon"
    })
  },
  methods: {
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("data-management-client/addClient", this.form)
        .then(data => {
          this.$router.push({ name: "Client", params: { clientId: data } });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>

<style></style>
